module.exports = "<div id=\"left-panel\" class=\"shop-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/views/left-panel.view.html
// module id = 810
// module chunks = 0